__turbopack_context__.v({
  "blockList": "QuicklinkBlock-module-scss-module__AN8aOG__blockList",
  "blocksBackgroundColor": "QuicklinkBlock-module-scss-module__AN8aOG__blocksBackgroundColor",
  "blocksFontColor": "QuicklinkBlock-module-scss-module__AN8aOG__blocksFontColor",
  "editNodeButton": "QuicklinkBlock-module-scss-module__AN8aOG__editNodeButton",
  "editNodeTitle": "QuicklinkBlock-module-scss-module__AN8aOG__editNodeTitle",
  "linkItem": "QuicklinkBlock-module-scss-module__AN8aOG__linkItem",
  "linkItemFolder": "QuicklinkBlock-module-scss-module__AN8aOG__linkItemFolder",
  "linkItemFolderClosed": "QuicklinkBlock-module-scss-module__AN8aOG__linkItemFolderClosed",
  "linkItemOnTerrace": "QuicklinkBlock-module-scss-module__AN8aOG__linkItemOnTerrace",
  "linkItemOnTerraceFolder": "QuicklinkBlock-module-scss-module__AN8aOG__linkItemOnTerraceFolder",
  "sbSub": "QuicklinkBlock-module-scss-module__AN8aOG__sbSub",
  "secondaryNavBackgroundColor": "QuicklinkBlock-module-scss-module__AN8aOG__secondaryNavBackgroundColor",
  "themeBackgroundColor": "QuicklinkBlock-module-scss-module__AN8aOG__themeBackgroundColor",
  "themeFontColor": "QuicklinkBlock-module-scss-module__AN8aOG__themeFontColor",
  "treeNode": "QuicklinkBlock-module-scss-module__AN8aOG__treeNode",
});
